import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import { membersReducer } from '../features/member.slice';
import { authenticationApi } from '../Services/API/auth.api';
import persistReducer from 'redux-persist/es/persistReducer'
import { quotesApi } from 'Services/API/quote.api';
import storage from "redux-persist/lib/storage/session"
import { cmsApi } from 'Services/API/cms.api';
import { lmsApi } from 'Services/API/lms.api';



const persistConfig = {
  key: `STORE_IMBAA`,
  storage,
}

const reducers = combineReducers({
  members: membersReducer,
  [authenticationApi.reducerPath]: authenticationApi.reducer,
  [quotesApi.reducerPath]: quotesApi.reducer,
  [cmsApi.reducerPath]: cmsApi.reducer,
  [lmsApi.reducerPath]:lmsApi.reducer
})

const persistedReducer = persistReducer(persistConfig, reducers)


export const store = configureStore({
  reducer: persistedReducer,
  middleware: (gDM) =>
    gDM({ serializableCheck: false }).concat(
      authenticationApi.middleware,
      quotesApi.middleware,
      cmsApi.middleware,
      lmsApi.middleware
    ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
